<template>
    <div class="top-count-row">

        <div @click="navToApproveAgent" v-if="sysBookingNum && sysBookingNum.pendingagents"
             class="box-wrapper justify-content-between d-flex flex-column c-pointer hover-shadow">
            <div class="top">
                <div class="left">
                    <div class="icon">
                        <img src="@imgPath/img/svg/pending.svg" alt="">
                    </div>
                    <div class="name-t">
                      {{$t('dashBoard.cSysBookingNo.pendingAgentRegistration')}} 
                    </div>
                </div>
                <div class="right align-items-baseline">
                    <div class="number" v-c-tooltip.hover="{content:sysBookingNum.pendingagents+ ' ' + $t('dashBoard.cSysBookingNo.todayIssuedBooking') , active:false }">
                        {{sysBookingNum.pendingagents}}
                    </div>
                </div>


            </div>
            <div class="bottom">
                <div class="progressbar">
                    <CProgress
                            class="progress-sm mt-2"
                            :precision="1"
                            color="info"
                            :value="50"
                    />
                </div>
            </div>
        </div>
        <div v-if="sysBookingNum" class="box-wrapper justify-content-between  d-flex flex-column">

            <div class="top">
                <div class="left">
                    <div class="icon">
                        <img src="@imgPath/img/svg/icons/coin.svg" alt="">
                    </div>
                    <div class="name-t">
                        {{$t('dashBoard.cSysBookingNo.todaySales')}} 
                    </div>
                </div>
                <div class="right flex-flow-column align-items-baseline">
                    <div class="number" v-for="(sales,index) in sysBookingNum.todaysales" :key="'sales'+index" v-c-tooltip.hover="{ content:Object.keys(sales)+' '+Object.values(sales) + ' ' + $t('dashBoard.cSysBookingNo.todaySales') , active:false }">
                        {{Object.keys(sales)+' '+Object.values(sales)}}
                    </div>


                </div>
                <div v-if="sysBookingNum.todaysales==null" class="right">
                    <div class="number" v-c-tooltip.hover="{ content:'0' + ' ' + $t('dashBoard.cSysBookingNo.todaySales') , active:false }">
                        0
                    </div>
                </div>
            </div>
            <div class="bottom">

                <div class="progressbar">
                    <CProgress
                            class="progress-sm mt-2"
                            :precision="1"
                            color="green"
                            :value="salesMaxVal"
                    />
                </div>
            </div>
        </div>
        <div @click="navigateToBooking" v-if="sysBookingNum && sysBookingNum.today_issuedbookings"
             class="box-wrapper justify-content-between d-flex flex-column c-pointer hover-shadow">
            <div class="top">
                <div class="left">
                    <div class="icon">
                        <img src="@imgPath/img/svg/icons/ticket-now-gray.svg" alt="">
                    </div>
                    <div class="name-t">
                     {{$t('dashBoard.cSysBookingNo.todayIssuedBooking')}}
                    </div>
                </div>
                <div class="right align-items-baseline">
                    <div class="number" v-c-tooltip.hover="{ content:sysBookingNum.today_issuedbookings + ' ' + $t('dashBoard.cSysBookingNo.todayIssuedBooking') , active:false }">
                        <!-- 23 -->
                        {{sysBookingNum.today_issuedbookings}}
                    </div>
                </div>


            </div>
            <div class="bottom">
                <div class="progressbar">
                    <div class="progress-bar-wrap">
                        <CProgress
                                class="progress-sm mt-2"
                                :precision="1"
                                color="purple "
                                :value="issuedMaxVal"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div @click="navToPostpaidPayment" v-if="sysBookingNum && sysBookingNum.pendingstatements"
             class="box-wrapper d-flex flex-column c-pointer justify-content-between hover-shadow">
            <div class="top">
                <div class="left">
                    <div class="icon">
                        <img src="@imgPath/img/svg/icons/analyse_primit.svg" alt="">
                    </div>
                    <div class="name-t">
                      {{$t('dashBoard.cSysBookingNo.outstandingPostpaidInvoice')}}
                    </div>
                </div>
                <div class="right align-items-baseline">
                    <div class="number" v-c-tooltip.hover="{ content:sysBookingNum.pendingstatements + ' ' + $t('dashBoard.cSysBookingNo.outstandingPostpaidInvoice') , active:false }">
                        {{sysBookingNum.pendingstatements}}
                    </div>
                </div>


            </div>
            <div class="bottom">
                <div class="progressbar">
                    <CProgress
                            class="progress-sm mt-2"
                            :precision="1"
                            color="red "
                            :value="50"
                    />
                </div>
            </div>
        </div>


    </div>
</template>
<script>
    import Logger from "../../../services/logger";
    import {VALIDATE_SUCCESS_RES, getErrorMessage} from "@/util/apiValidate.js";
    import router, {navigate, goBack} from "../../../router/index";
    import apiGetSysBookingNumber from "./../../../services/apiGetSysBookingNumber";
    import {
        LOG_TYPE,
        FILE_NAME,
        HTTP_CODES,
        API_VALUES
    } from "../../../config/API_DATA";
    import {COMPONENT_NAME, PATHNAME, ROUTER_PARAM, BOOKING_STATUS} from "../../../util/constants";
    import BaseConfiguration from "../../../config/base.js";
    import SERVICE_URL from "../../../config/API_DATA";
    import {mapGetters, mapActions} from "vuex";
    import {handleJWT, getErrorAlertValue} from "../../../util/util";
    import cBookingDetail from '../../../store/modules/pages/ticket/cBookingDetail';

    export default {
        name: COMPONENT_NAME.C_SYS_BOOKING_NUMBER,

        data() {
            return {
                // sysBookingNum : null,
                salesMaxVal: null,
                issuedMaxVal: null
            }
        },

        props: {
            prgrsBarData: {
                type: Object,
                default: null
            },
            sysBookingNum: {
                type: Object,
                default: null
            },

        },

        computed: {
            ...mapGetters("sSysLogin", {
                ADMIN_SIGNIN_RES: "GET_ADMIN_SIGNIN_RES"
            }),
        },
        async created() {
            if (BaseConfiguration.isDebug) console.log("created");
            try {
                // alert(this.prgrsBarData);
                if (this.ADMIN_SIGNIN_RES) {
                    // this.sysBookingNum = await this.getSysBookingNumber();

                    this.toGetPrgrsBarMaxVal(this.prgrsBarData);

                }
            } catch (err) {
                let body = Logger.buildRequest(
                    COMPONENT_NAME.C_SYS_BOOKING_NUMBER,
                    "error in  Created",
                    err.toString(),
                    " Created()",
                    LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
            }
        },

        methods: {
            ...mapActions("sCSystemDeposit", {
                SET_OVER_DUE_FILTER: "SET_OVER_DUE_FILTER"
            }),

            ...mapActions("sDashBoard", {
                SET_NAV_BOOL: "SET_NAV_BOOL"
            }),

            navigateToBooking() {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("navigateToBooking");
                    this.SET_NAV_BOOL(true);
                    navigate(PATHNAME.MY_BOOKING);

                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYS_BOOKING_NUMBER,
                        "error in navigateToBooking",
                        err.toString(),
                        "navigateToBooking",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            navToPostpaidPayment() {
                try {
                    if (BaseConfiguration.isDebug) console.log("navToPostpaidPayment");
                    this.SET_OVER_DUE_FILTER(true);
                    navigate(PATHNAME.DEPOSIT);

                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYS_BOOKING_NUMBER,
                        "error in navToPostpaidPayment",
                        err.toString(),
                        "navToPostpaidPayment",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },
            navToApproveAgent() {
                try {
                    if (BaseConfiguration.isDebug) console.log("navToApproveAgent");

                    navigate(PATHNAME.APPROVE_AGENT);

                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYS_BOOKING_NUMBER,
                        "error in navToApproveAgent",
                        err.toString(),
                        "navToApproveAgent",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },

            showAlert(val) {
                this.$emit("showAlert", val);
            },
            toGetPrgrsBarMaxVal(pdayToDaySalesRes) {
                let sales = 0;
                let issuedbookings = 0;
                try {
                    if (BaseConfiguration.isDebug) console.log("toGetPrgrsBarMaxVal");
                    if (pdayToDaySalesRes) {

                        if (pdayToDaySalesRes.dayTodaySales.lastweek_sameday) {
                            for (let i = 0; i < pdayToDaySalesRes.dayTodaySales.lastweek_sameday.length; i++) {
                                sales += pdayToDaySalesRes.dayTodaySales.lastweek_sameday[i].json_build_object.Sales;
                                issuedbookings += pdayToDaySalesRes.dayTodaySales.lastweek_sameday[i].json_build_object.IssuedBookings;

                            }
                        }
                    }
                    this.salesMaxVal = sales;
                    this.issuedMaxVal = issuedbookings;
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SYS_BOOKING_NUMBER,
                        "error in toGetPrgrsBarMaxVal",
                        err.toString(),
                        "toGetPrgrsBarMaxVal",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },

            async getSysBookingNumber() {
                if (BaseConfiguration.isDebug) console.log("getSysBookingNumber");
                let returnValue;
                try {
                    let getBookingNumberReq = apiGetSysBookingNumber.buildRequest(); //constant

                    if (getBookingNumberReq != null) {
                        let getBookingNumberRes = await apiGetSysBookingNumber.getResponse(
                            getBookingNumberReq
                        );
                        if (VALIDATE_SUCCESS_RES(getBookingNumberRes)) {
                            returnValue = getBookingNumberRes.data.data;

                        } else {
                            let error = getErrorMessage(getBookingNumberRes);

                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.showAlert(getErrorAlertValue(error));
                            }
                        }
                    } else {
                        throw "invalid request";
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_SYS_BOOKING_NUMBER,
                        "error in  getSysBookingNumber",
                        err.toString(),
                        "getSysBookingNumber()",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return returnValue;
            },
        }
    }

</script>
<style>
    main.c-main {
        background: #f2f4f5;
    }
</style>